export const buildConfig={date:"Wed Mar 12 17:23:30 GMT 2025"}
